
export const listFonctionAdminKerlog = [
    {
        libelle: 'Fonctions', submenus: [
            {
                id: 1, libelle: 'Fonctions', route: '/recylog/fonctionAdminKerlog/fonctions/AdminTexteLibre',  libelleObjetEntite: 'Modifications des textes libres'
            },
            {
                id: 2, libelle: 'Fonctions', route: '/recylog/fonctionAdminKerlog/fonctions/AdministrationOperationSupp',  libelleObjetEntite: 'Ajout d\'opérations de bennes supplémentaire'
            },
            {
                id: 3, libelle: 'Fonctions', route: '/recylog/fonctionAdminKerlog/fonctions/administrationSociete',  libelleObjetEntite: 'Administration de la société'
            },
            //  id: 4 deplacer dans fonctionAdmin/eco^pol
            {
                id: 7, libelle: 'Fonctions', route: '/recylog/fonctionAdminKerlog/fonctions/gestionLicenceEcorec',  libelleObjetEntite: 'Mettre à jour le nombre de licence Ecorec'
            },
            {
                id: 8, libelle: 'Fonctions', route: '/recylog/fonctionAdminKerlog/fonctions/journalAdministration',  libelleObjetEntite: ' Journal des Opérations d\'administration '
            },
            {
                id: 9, libelle: 'Fonctions', route: '/recylog/fonctionAdminKerlog/fonctions/MAJLibelleNegocieBonContrat',  libelleObjetEntite: 'Mise à jour des libellés negociés de bons et contrats'
            },
            {
                id: 10, libelle: 'Fonctions', route: '/recylog/fonctionAdminKerlog/fonctions/paramServeur',  libelleObjetEntite: 'Affichage des informations systeme'
            },
            {
                id: 11, libelle: 'Fonctions', route: '/recylog/fonctionAdminKerlog/fonctions/reqExcel',  libelleObjetEntite: 'Requêteur SQL'
            },
            {
                id: 12, libelle: 'Fonctions', route: '/recylog/fonctionAdminKerlog/fonctions/selectionChampFicheClientParSite',  libelleObjetEntite: 'Sélection des champs de la fiche client qui ont une valeur par site'
            },
            {
                id: 13, libelle: 'Fonctions', route: '/recylog/fonctionAdminKerlog/fonctions/suppressionBapCompta',  libelleObjetEntite: 'Validation compta de bon d\'achat'
            },
            {
                id: 14, libelle: 'Fonctions', route: '/recylog/fonctionAdminKerlog/fonctions/visibiliteChampFicheClient',  libelleObjetEntite: 'Modification de la visibilité des champs de la fiche client'
            },
            {
                id: 15, libelle: 'Fonctions', route: '/recylog/fonctionAdminKerlog/fonctions/visibiliteChampFicheChantier',  libelleObjetEntite: 'Modification de la visibilité des champs de la fiche chantier'
            },
            {
                id: 24, libelle: 'Fonctions', route: '/recylog/fonctionAdminKerlog/fonctions/admin_ecoportail',  libelleObjetEntite: 'Administration EcoPortail'
            },
            // id utilisé dans Administration EcoPortail : 24, 25, 26 et 27
            {
                id: 31, libelle: 'Fonctions', route: '/recylog/fonctionAdminKerlog/fonctions/update_manager',  libelleObjetEntite: 'Update Manager'
            },
            {
                id: 32, libelle: 'Fonctions', route: '/recylog/fonctionAdminKerlog/fonctions/renommerTypeClient',  libelleObjetEntite: 'Renommer type client'
            },
            {
                id: 33, libelle: 'Fonctions', route: '/recylog/fonctionAdminKerlog/fonctions/departementRechercheAdresse',  libelleObjetEntite: 'Gestion département recherche adresse'
            },
            {
                id: 34, libelle: 'Fonctions', route: '/recylog/fonctionAdminKerlog/fonctions/admin_etat_bac',  libelleObjetEntite: 'Administration Etat Bac'
            },
            {
                id: 35, libelle: 'Fonctions', route: '/recylog/fonctionAdminKerlog/fonctions/activationBadge',  libelleObjetEntite: 'Mail/SMS activation badge'
            },
            {
                id: 42, libelle: 'Fonctions', route: '/recylog/fonctionAdminKerlog/fonctions/synchroBAN', libelleObjetEntite: 'Modification en masse de la BAK'
            },
            {
                id: 36, libelle: 'Fonctions', route: '/recylog/fonctionAdminKerlog/fonctions/OperationSuppHolding', libelleObjetEntite: 'Ajout d`\'opérations de bennes supp en holding'
            },  
            {
                id: 37, libelle: 'Fonctions', route: '/recylog/fonctionAdminKerlog/fonctions/compte_goodflag', libelleObjetEntite: 'Modification du compte Goodflag'
            },   
        ],
    },
    {
        libelle: 'Paramétrage', submenus: [
            {
                id: 17, libelle: 'Paramétrage', route: '/recylog/fonctionAdminKerlog/parametrage/administrationParamECOBM',  libelleObjetEntite: 'Droits EcoBM'
            },
            {
                id: 18, libelle: 'Paramétrage', route: '/recylog/fonctionAdminKerlog/parametrage/administrationParamEcoLM',  libelleObjetEntite: 'Droits EcoLM'
            },
            {
                id: 19, libelle: 'Paramétrage', route: '/recylog/fonctionAdminKerlog/parametrage/administrationParamEcoBAM',  libelleObjetEntite: 'Droits EcoBAM'
            },
            {
                id: 20, libelle: 'Paramétrage', route: '/recylog/fonctionAdminKerlog/parametrage/administrationParamEcoGM',  libelleObjetEntite: 'Droits EcoGM'
            },
            {
                id: 21, libelle: 'Paramétrage', route: '/recylog/fonctionAdminKerlog/parametrage/administrationParamEcoTM',  libelleObjetEntite: 'Droits EcoTM'
            },
            {
                id: 22, libelle: 'Paramétrage', route: '/recylog/fonctionAdminKerlog/parametrage/administrationParamEcodecheterie',  libelleObjetEntite: 'Droits EcoDecheterie'
            },
            {
                id: 23, libelle: 'Paramétrage', route: '/recylog/fonctionAdminKerlog/parametrage/administrationParamEcoPortail',  libelleObjetEntite: 'Droits EcoPortail'
            },
            {
                id: 28, libelle: 'Paramétrage', route: '/recylog/fonctionAdminKerlog/parametrage/administrationParamEcobadge',  libelleObjetEntite: 'Ecobadge'
            },
            // id utilisé dans EcoPortail : 28, 29 et 30
        ],
    }
]